export default "__VITE_ASSET__f4f55e66__"